import React from 'react';

import {FormControl, FormHelperText, FormLabel, Select} from '@chakra-ui/react';

import {Controller, useFormContext} from 'react-hook-form';

import {QuestionProps} from './question';

export function SelectQuestion(props: Readonly<QuestionProps>) {
  const {question} = props;
  const {control} = useFormContext();

  const options = question.options.map(it => (
    <option key={it.id} value={it.id}>
      {it.value}
    </option>
  ));

  return (
    <FormControl>
      <FormLabel>{question.title}</FormLabel>
      <Controller
        control={control}
        name={question.id}
        render={({field: {onChange, value}}) => (
          <Select
            placeholder='-- Selecciona una opción --'
            onChange={onChange}
            value={value}>
            {options}
          </Select>
        )}
      />
      <FormHelperText>{question.description}</FormHelperText>
    </FormControl>
  );
}
